import { useSupabaseClient } from '~/composables/useSupabaseClient';
import { useSupabaseUser } from '~/composables/useSupabaseUser';

/**
 * This global middleware is the first to run on every route change.
 * Its primary purpose is to resolve the user's authentication state before any
 * other middleware or page logic is executed.
 *
 * It solves a classic race condition caused by the asynchronous session
 * restoration in the Supabase V2 client. On initial app load, other middlewares
 * could run *before* the `useSupabaseUser()` state is populated. This middleware
 * prevents that by explicitly awaiting `supabase.auth.getClaims()`, which forces
 * Nuxt's rendering to pause until the user's identity is confirmed.
 *
 * The check for an existing `user.value` provides a fast path for subsequent
 * client-side navigations where the user state is already hydrated.
 */
export default defineNuxtRouteMiddleware(async () => {
	const user = useSupabaseUser();

	if (user.value) {
		return;
	}

	const supabase = useSupabaseClient();

	// This is absolutely bad practice because we mutate the state from a library but because the library has this bug an the moment we need to do this
	const newUser = await supabase.auth.getClaims();
	user.value = newUser.data?.claims ?? null;
});
